import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import type { ReclaimitFormStoryblok } from "@/generated/sb/sb-types";

// Matches the height used on the existing ellaandil.com page; the iframe
// scrolls internally for taller form states.
const IFRAME_HEIGHT_PX = 400;

export const ReclaimitFormBlok = ({ blok }: BlokProps<ReclaimitFormStoryblok>) => {
	if (!blok.reclaimItEmbedUrl) return null;

	return (
		<BlokWrap
			editable={blok}
			className="flex w-full flex-col items-center justify-center pb-grid-section-vertical-lg"
		>
			<iframe
				src={blok.reclaimItEmbedUrl}
				title="Reclaimit return form"
				width="100%"
				height={IFRAME_HEIGHT_PX}
				className="block w-full max-w-[620px] border-0"
			/>
		</BlokWrap>
	);
};
